import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../styles/theme';
import { fadeInScale, resultPulse, withMotion } from '../styles/animations';

const ResultCard = ({ label, value, unit, testId, empty, note }) => (
  <Card empty={empty ? 1 : 0} hasValue={!empty && value ? 1 : 0}>
    <CardLabel>{label}</CardLabel>
    <MetricRow>
      <MetricValue data-testid={testId} empty={empty ? 1 : 0}>
        {empty ? '—' : value}
      </MetricValue>
      {!empty && value && <MetricUnit>{unit}</MetricUnit>}
    </MetricRow>
    {note && !empty && <Note>{note}</Note>}
  </Card>
);

const Card = styled.article`
  background: ${theme.colors.resultBg};
  border: 1px solid ${({ empty }) =>
    empty ? theme.colors.borderSoft : theme.colors.resultBorder};
  border-radius: ${theme.radius.xl};
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  box-shadow: ${({ empty }) => (empty ? 'none' : theme.shadows.resultCard)};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  transition: border-color 0.25s ease, box-shadow 0.25s ease, opacity 0.25s ease;
  opacity: ${({ empty }) => (empty ? 0.45 : 1)};

  ${withMotion(css`
    animation: ${fadeInScale} 0.4s ease both;
    animation-delay: 0.1s;
  `)}

  ${({ hasValue }) =>
    hasValue &&
    withMotion(css`
      animation: ${resultPulse} 0.6s ease;
    `)}

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    border-radius: ${theme.radius.lg};
  }
`;

const CardLabel = styled.p`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: ${theme.colors.textMuted};
`;

const MetricRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${theme.spacing.sm};
`;

const MetricValue = styled.span`
  font-family: ${theme.typography.fontMono};
  font-size: clamp(26px, 5vw, 40px);
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1;
  transition: color 0.2s ease;
  color: ${({ empty }) =>
    empty ? theme.colors.textMuted : theme.colors.skyBlueLight};
`;

const MetricUnit = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${theme.colors.textSecondary};
  letter-spacing: 0.5px;
`;

const Note = styled.p`
  font-size: 10px;
  color: ${theme.colors.textMuted};
  letter-spacing: 0.3px;
  margin-top: 2px;
`;

export default ResultCard;
